require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-crm-delivery-manager-india.json") })
        }
      }, "path---careers-crm-delivery-manager-india");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-crm-delivery-manager-india!./.cache/json/careers-crm-delivery-manager-india.json
// module id = 853
// module chunks = 231608221292675